import type { SVGProps } from "react";
import * as React from "react";

export const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0073 15.75C12.4215 15.75 12.7573 16.0858 12.7573 16.5C12.7573 16.9142 12.4215 17.25 12.0073 17.25H12C11.5858 17.25 11.25 16.9142 11.25 16.5C11.25 16.0858 11.5858 15.75 12 15.75H12.0073Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 3.75C16.9926 3.75 18 4.75736 18 6V18C18 19.2426 16.9926 20.25 15.75 20.25H8.25C7.00736 20.25 6 19.2426 6 18V6C6 4.75736 7.00736 3.75 8.25 3.75H15.75ZM8.25 5.25C7.83579 5.25 7.5 5.58579 7.5 6V18C7.5 18.4142 7.83579 18.75 8.25 18.75H15.75C16.1642 18.75 16.5 18.4142 16.5 18V6C16.5 5.58579 16.1642 5.25 15.75 5.25H8.25Z"
      fill="currentColor"
    />
  </svg>
);
